import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalculator } from "@fortawesome/free-solid-svg-icons";
import SearchField from "../SearchField/SearchField";
import SPQSFormGroup from "./SPQSFormGroup";
import useSPQS from "../../hooks/useSPQS";
import useSPQSUndo from "../../hooks/useSPQSUndo";
import useGlobalParams from "../../hooks/useGlobalParams";
import { handleFigureChange, handleFigureBlur, handleInputSelect, addEdits } from "./utils/inputhandlers";

const QSSPFigures = ({
  ignoreEnter,
  setShowcalculator,
  showcalculator,
  resetOutbound,
  resetOceanfreight,
  resetCustoms,
  resetInbound,
  clearfield,
}) => {
  // Load context values
  const { SPQS, setSPQS, setSPQSData } = useSPQS();
  const { SPQSEdits, editIDSPQS, setEditIDSPQS, editingFieldSPQS, setEditingFieldSPQS, undoListSPQS, inputRefsSPQS } =
    useSPQSUndo();
  const { globalparams } = useGlobalParams();

  // Local handleFigureChange and handleFigureBlur functions to allow shorthand in input component.
  const localHandleFigureChange = (e, type, dec = 2) => {
    handleFigureChange(e, type, setSPQS, setSPQSData, setEditingFieldSPQS, dec);
  };
  const localHandleFigureBlur = (e, type, dec = 2) => {
    handleFigureBlur(
      e,
      type,
      setSPQS,
      SPQSEdits,
      editIDSPQS,
      setEditIDSPQS,
      editingFieldSPQS,
      setEditingFieldSPQS,
      undoListSPQS,
      dec
    );
  };
  const localHandleInputSelect = (item, origin, destination) => {
    handleInputSelect(
      item,
      SPQSEdits,
      editIDSPQS,
      setEditIDSPQS,
      setSPQS,
      setSPQSData,
      addEdits,
      undoListSPQS,
      origin,
      destination,
      globalparams
    );
  };
  return (
    <>
      <fieldset>
        <legend>Figures:</legend>
        <div className='form-group'>
          <label>Quantity (mt):</label>
          <div className='USqtyandtolerance'>
            <input
              required
              autoComplete='off'
              type='text'
              name='quantity'
              value={SPQS?.quantity || ""}
              onKeyDown={ignoreEnter}
              onFocus={(e) => e.target.select()}
              onChange={(e) => localHandleFigureChange(e, "decimal")}
              onBlur={(e) => localHandleFigureBlur(e, "decimal")}
              ref={(el) => (inputRefsSPQS.current["quantity"] = el)}
            />
            <p>+/-</p>
            <input
              required
              style={{ minWidth: "35px", maxWidth: "45px" }}
              value={SPQS?.tolerance || ""}
              onFocus={(e) => e.target.select()}
              // onChange={(e) => handlePercentageChange(e, setUSposition, setUSpositionData, 2)}
              onChange={(e) => localHandleFigureChange(e, "percent", 2)}
              // onBlur={(e) => handlePercentageBlur(e, setUSposition, 2)}
              onBlur={(e) => localHandleFigureBlur(e, "percent", 2)}
              onKeyDown={ignoreEnter}
              name='tolerance'
              placeholder='% ...'
              ref={(el) => (inputRefsSPQS.current["tolerance"] = el)}
            />
          </div>
        </div>
        <SPQSFormGroup labelname={"# Pallets"} inputname={"numpallets"} inputtype={"decimal"} />
      </fieldset>
      <fieldset>
        <legend>Costs (per mt):</legend>
        <SPQSFormGroup
          labelname={SPQS.qstype === 2 ? "Landed Cost" : " Material Cost"}
          inputname={"materialcost"}
          inputtype={"currency"}
        />
        {SPQS.qstype !== 2 && (
          <>
            <SPQSFormGroup labelname={"P Commission"} inputname={"pcomission"} inputtype={"currency"} />
            <SPQSFormGroup labelname={"P Finance Cost"} inputname={"pfinancecost"} inputtype={"currency"} />{" "}
          </>
        )}
        {SPQS.qstype == 2 && <SPQSFormGroup readOnly={true} labelname={"Storage Cost"} inputname={"storagecost"} />}
        <div className='form-group'>
          <label>
            Outbound Cost:{" "}
            <FontAwesomeIcon
              icon={faCalculator}
              onClick={(e) => {
                setShowcalculator("outboundcost");
              }}
            />
          </label>
          <input
            readOnly
            required
            type='text'
            name='outboundcost'
            value={SPQS?.outboundcost || ""}
            onKeyDown={ignoreEnter}
            onFocus={(e) => e.target.select()}
          />
        </div>
        {showcalculator === "outboundcost" && (
          <div className='SPbottompopupcalculator' style={{ position: "absolute" }}>
            <SPQSFormGroup labelname={"Payload (mt/FCL)"} inputname={"outpayload"} inputtype={"decimal"} />
            <SPQSFormGroup labelname={"Drayage per FCL"} inputname={"outdrayage"} inputtype={"currency"} />
            <SPQSFormGroup labelname={"Loading Fee per FCL"} inputname={"loading"} inputtype={"currency"} />
            <SPQSFormGroup labelname={"Collect Charges"} inputname={"outcollectcharges"} inputtype={"currency"} />
            <SPQSFormGroup labelname={"Outbound others"} inputname={"outboundothers"} inputtype={"currency"} />
            <SPQSFormGroup readOnly={true} labelname={"Total Outbound"} inputname={"totaloutbound"} />
            <button
              onClick={(e) => {
                e.preventDefault();
                // setEditing(true);
                resetOutbound();
              }}
            >
              Reset
            </button>
            <button
              onClick={(e) => {
                e.preventDefault();
                setShowcalculator("");
              }}
            >
              OK
            </button>
          </div>
        )}
        {SPQS.qstype !== 2 && (
          <div className='form-group'>
            <label>
              Ocean Freight:
              <FontAwesomeIcon
                icon={faCalculator}
                onClick={(e) => {
                  setShowcalculator("oceanfreight");
                }}
              />
            </label>
            <input
              readOnly
              required
              type='text'
              name='freightpmt'
              value={SPQS?.freightpmt || ""}
              onKeyDown={ignoreEnter}
              onFocus={(e) => e.target.select()}
            />
          </div>
        )}
        {showcalculator === "oceanfreight" && (
          <div className='SPbottompopupcalculator' style={{ position: "absolute" }}>
            <SPQSFormGroup labelname={"Payload (mt)"} inputname={"oceanpayload"} inputtype={"decimal"} />
            <SPQSFormGroup labelname={"Total Freight"} inputname={"oceanfreight"} inputtype={"currency"} />
            <button
              onClick={(e) => {
                e.preventDefault();
                resetOceanfreight();
              }}
            >
              Reset
            </button>
            <button
              onClick={(e) => {
                e.preventDefault();
                setShowcalculator("");
              }}
            >
              OK
            </button>
          </div>
        )}
        {SPQS.qstype !== 2 && (
          <div className='form-group'>
            <label>
              Import Customs Fee:{" "}
              <FontAwesomeIcon
                icon={faCalculator}
                onClick={(e) => {
                  setShowcalculator("importcustomsfee");
                }}
              />
            </label>
            <input
              readOnly
              required
              type='text'
              name='importcustomsfee'
              value={SPQS?.importcustomsfee || ""}
              onKeyDown={ignoreEnter}
              onFocus={(e) => e.target.select()}
            />
          </div>
        )}
        {showcalculator === "importcustomsfee" && (
          <div className='SPbottompopupcalculator' style={{ position: "absolute" }}>
            <SPQSFormGroup labelname={"Quantity"} inputname={"quantity"} inputtype={"decimal"} />
            <SPQSFormGroup labelname={"Material Cost/mt"} inputname={"materialcost"} inputtype={"currency"} />
            <SPQSFormGroup readOnly={true} labelname={"Material Value"} inputname={"materialvalue"} />
            <SPQSFormGroup labelname={"General Duty(%)"} inputname={"generaldutyimp"} inputtype={"percent"} />
            <SPQSFormGroup labelname={"Additional Duty(%)"} inputname={"additionaldutyimp"} inputtype={"percent"} />
            <SPQSFormGroup readOnly={true} labelname={"Total Duty(%)"} inputname={"totalduty"} />
            <SPQSFormGroup readOnly={true} labelname={"Duty Fee"} inputname={"dutyfee"} />
            <SPQSFormGroup labelname={"Harbor Fee(%)"} inputname={"harborfeepct"} inputtype={"percent"} />
            <SPQSFormGroup readOnly={true} labelname={"Harbor Fee"} inputname={"harborfee"} />
            <SPQSFormGroup labelname={"Merch. Proc. Fee(%)"} inputname={"merchprocfeepct"} inputtype={"percent"} />
            <SPQSFormGroup readOnly={true} labelname={"Merch. Proc. Fee"} inputname={"merchprocfee"} />
            <SPQSFormGroup labelname={"Flat fee"} inputname={"flatfee"} inputtype={"currency"} />
            <SPQSFormGroup labelname={"TSCA"} inputname={"tsca"} inputtype={"currency"} />
            <SPQSFormGroup labelname={"ISF"} inputname={"isf"} inputtype={"currency"} />
            <SPQSFormGroup readOnly={true} labelname={"Total Entry Fee"} inputname={"totalcentryfee"} />
            <button
              onClick={(e) => {
                e.preventDefault();
                // setEditing(true);
                resetCustoms();
              }}
            >
              Reset
            </button>
            <button
              onClick={(e) => {
                e.preventDefault();
                setShowcalculator("");
              }}
            >
              OK
            </button>
          </div>
        )}
        {SPQS.qstype !== 2 && (
          <div className='form-group'>
            <label>
              Inbound Cost:{" "}
              <FontAwesomeIcon
                icon={faCalculator}
                onClick={(e) => {
                  setShowcalculator("inboundcost");
                }}
              />
            </label>
            <input
              readOnly
              required
              type='text'
              name='inboundcost'
              value={SPQS?.inboundcost}
              onKeyDown={ignoreEnter}
              onFocus={(e) => e.target.select()}
            />
          </div>
        )}
        {showcalculator === "inboundcost" && (
          <div className='SPbottompopupcalculator' style={{ position: "absolute" }}>
            <SPQSFormGroup labelname={"Payload (mt/FCL)"} inputname={"inpayload"} inputtype={"decimal"} />
            <SPQSFormGroup labelname={"Drayage per FCL"} inputname={"indrayage"} inputtype={"currency"} />
            <SPQSFormGroup labelname={"Loading Fee per FCL"} inputname={"unloading"} inputtype={"currency"} />
            <SPQSFormGroup labelname={"Collect Charges"} inputname={"incollectcharges"} inputtype={"currency"} />
            <SPQSFormGroup labelname={"Outbound others"} inputname={"inboundothers"} inputtype={"currency"} />
            <SPQSFormGroup readOnly={true} labelname={"Total Inbound"} inputname={"totalinbound"} />
            <button
              onClick={(e) => {
                e.preventDefault();
                // setEditing(true);
                resetInbound();
              }}
            >
              Reset
            </button>
            <button
              onClick={(e) => {
                e.preventDefault();
                setShowcalculator("");
              }}
            >
              OK
            </button>
          </div>
        )}
        <SPQSFormGroup labelname={"S Comission"} inputname={"scomission"} inputtype={"currency"} />
        <SPQSFormGroup labelname={"S Finance Cost"} inputname={"sfinancecost"} inputtype={"currency"} />
        <SPQSFormGroup labelname={"Inspection Cost"} inputname={"inspectioncost"} inputtype={"currency"} />
        <SPQSFormGroup labelname={"Legal"} inputname={"legal"} inputtype={"currency"} />
        <SPQSFormGroup labelname={"Pallets"} inputname={"pallets"} inputtype={"currency"} />
        <SPQSFormGroup labelname={"Other"} inputname={"other"} inputtype={"currency"} />
        <SPQSFormGroup
          readOnly={true}
          labelname={"Total Cost"}
          inputname={"totalcost"}
          rowStyle={{ marginTop: "1rem" }}
        />
        <div style={{ marginTop: "1.5rem" }} className='form-group'>
          <label style={{ position: "relative" }}>
            Insurance Cost:{" "}
            <FontAwesomeIcon
              icon={faCalculator}
              onClick={(e) => {
                setShowcalculator("insurance");
              }}
            />
          </label>
          <input type='text' name='insurancecost' readOnly value={SPQS.insurancecost || ""} onKeyDown={ignoreEnter} />
        </div>
        {showcalculator === "insurance" && (
          <div className='SPbottompopupcalculator' style={{ position: "absolute" }}>
            <div className='form-group'>
              <label htmlFor=''>D Incoterms:</label>
              <SearchField
                required={true}
                searchURL='/api/qs/getsincoterms'
                value={SPQS?.sincoterm || ""}
                valueName='sincoterm'
                valueID='sincotermID'
                customplaceholder='S Incoterm'
                onItemSelect={(item) => localHandleInputSelect(item, "sincoterm", "sincoterm")}
                clearfield={clearfield}
              />
            </div>
            <SPQSFormGroup labelname={"Insurance Rate %"} inputname={"insurancerate"} inputtype={"percent"} />
            <SPQSFormGroup labelname={"Insurance Factor"} inputname={"insurancefactor"} inputtype={"decimal"} />
            <button
              onClick={(e) => {
                e.preventDefault();
                setShowcalculator("");
              }}
            >
              OK
            </button>
          </div>
        )}
        <SPQSFormGroup readOnly={true} labelname={"Interest Cost"} inputname={"interestcost"} />
        <SPQSFormGroup
          readOnly={true}
          labelname={SPQS.qstype !== 2 ? "Total Landed Cost" : "Total Cost + Int + Ins"}
          inputname={"totallandedcost"}
          rowStyle={{ marginTop: "1rem" }}
        />
      </fieldset>
    </>
  );
};

export default QSSPFigures;
